<template>
	<div>
		Overview

		<router-link to="ibd-follow-up">test</router-link>
	</div>
</template>

<script>
export default {
	name: 'response-overview'
}
</script>
